// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"760":"67a55ea9","971":"4879a7e6"}[chunkId] + ".chunk.css";
};